"use client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../pages/Login/AuthForm";

const LoginModal = ({ open, onClose }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!open) return;

        const token = localStorage.getItem("token");
        const expiry = localStorage.getItem("tokenExpiry");

        if (!token || !expiry) return;

        // ❌ Token expired
        if (Date.now() > Number(expiry)) {
            localStorage.removeItem("token");
            localStorage.removeItem("tokenExpiry");
            localStorage.removeItem("user");
            return;
        }

        // ✅ Token valid
        navigate("/dashboard", { replace: true });
    }, [open, navigate]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center">
            {/* Overlay */}
            <div
                className="absolute inset-0 bg-black/70"
                onClick={onClose}
            ></div>

            {/* Modal Box */}
            <div className="relative z-10 w-full mx-4 max-w-md sm:max-w-lg md:max-w-xl">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute -top-2 right-3 bg-[#ef4444] text-white w-10 h-10 z-[999] rounded-full flex items-center justify-center text-xl shadow-lg hover:bg-red-500 transition"
                >
                    ✕
                </button>

                {/* AUTH FORM */}
                <div className="rounded-2xl overflow-hidden">
                    <AuthForm onSuccess={onClose} />
                </div>
            </div>
        </div>
    );
};

export default LoginModal;
